<template>
  <SpaceSettingsEditModalTemplate @close="$emit('close')">
    <template v-slot:title>{{ $t('editTitle') }}</template>
    <template v-slot:form>
      <ContractorsSettingsForm :edit_contractor="edit_contractor"
                               @cancelEdit="$emit('close')"/>
    </template>
  </SpaceSettingsEditModalTemplate>
</template>

<script>
import SpaceSettingsEditModalTemplate from "@/components/UI/SpaceSettings/SpaceSettingsEditModalTemplate";
import ContractorsSettingsForm from "@/components/cabinet/SpaceSettings/ContractorsSettings/ContractorsSettingsForm";

export default {
  name: "ContractorsSettingsEditModal",
  props: {
    edit_contractor: {
      type: Object
    }
  },
  components: {ContractorsSettingsForm, SpaceSettingsEditModalTemplate},
  i18n: {
    messages: {
      en: {
        editTitle: 'Edit contractor'
      },
      ru: {
        editTitle: 'Редактирование контрагента'
      }
    }
  }
}
</script>

<style scoped>

</style>